module.exports = __webpack_public_path__ + "img/roadmap-bubble-2.69c948bc.svg";